import { Box, SxProps, Theme } from '@mui/material';

import { resolvePhoneNumberFormat } from '@/utils';
import { BffWorkingHours } from '@/graphql/__generated/sdk';

import CustomTypography from './UI/Typography/CustomTypography';
import { headerStyles } from './Header.styles';
import OfficeStatus from './OfficeStatus';
import { ExtendedFacility } from './Header';

interface OfficeDetailsProps {
	facility: ExtendedFacility;
	distanceInMiles?: number;
	showPhoneAndStatus?: boolean;
}

export function OfficeDetails({ facility, distanceInMiles, showPhoneAndStatus }: OfficeDetailsProps) {
	if (!facility) return null;

	const address1 = facility.address?.address1 ?? '';
	const city = facility.address?.city ?? '';
	const stateCode = facility.address?.stateCode ?? '';
	const zipCode = facility.address?.zipCode ?? '';
	const addressLine = `${address1}, ${city}, ${stateCode} ${zipCode}`;

	return (
		<Box
			sx={
				[
					headerStyles.officeDetailsColumn,
					!showPhoneAndStatus && headerStyles.officeDetailsOverflow,
				] as SxProps<Theme>
			}
		>
			<CustomTypography variant="bodyS">
				{addressLine}
				{distanceInMiles ? ` • ${distanceInMiles.toFixed(1)} mi` : ''}
			</CustomTypography>

			{showPhoneAndStatus && (
				<>
					<CustomTypography variant="bodyS" className="InvocaNumber">
						{resolvePhoneNumberFormat(
							facility?.technicalInfrastructure?.phoneNumber || facility?.phoneNumber || ''
						)}
					</CustomTypography>

					<OfficeStatus
						workingHours={facility?.workingHours as BffWorkingHours[]}
						timeZoneId={facility?.location?.timeZone ?? ''}
					/>
				</>
			)}
		</Box>
	);
}
